import script from "./AddCrewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCrewModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCrewModal.vue?vue&type=style&index=0&id=2a45f36c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a45f36c"]])

export default __exports__